"use client";

import React from "react";
import { Stack, Paper } from "@mui/material";
import { ForgotPasswordComposite } from "../../../components/composites";
import { useWindowDimensions } from "@cbex/utils/hooks";
import Head from "next/head";
import { useTranslations } from "next-intl";

const ForgotPassword = () => {
  const windowSize = useWindowDimensions();
  const t = useTranslations();
  return (
    <Stack
      paddingTop={10}
      alignItems="center"
      height={windowSize.height}
      width="100%"
      id="ForgotPassword"
    >
      <Head>
        <title>{t("common.myCBEX")}</title>
      </Head>
      <Paper>
        <ForgotPasswordComposite />
      </Paper>
    </Stack>
  );
};

export default ForgotPassword;
